import { memo, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, useMediaQuery } from '@mui/material';

// project imports
import menuItem from 'menu-items';
import NavGroup from './NavGroup';
import LAYOUT_CONST from 'constant';
import { HORIZONTAL_MAX_ITEM } from 'config';
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const { layout } = useConfig();
    const { user } = useAuth();

    const userRole = user?.role || 'USER';

    const filteredMenu = useMemo(
        () => ({
            ...menuItem,
            items: menuItem.items.map((group) => ({
                ...group,
                children: (group.children || []).filter((item) => !item.roles || item.roles.includes(userRole))
            }))
        }),
        [userRole]
    );

    const lastItem = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd ? HORIZONTAL_MAX_ITEM : null;

    let lastItemIndex = filteredMenu.items.length - 1;
    let remItems = [];
    let lastItemId;

    if (lastItem && lastItem < filteredMenu.items.length) {
        lastItemId = filteredMenu.items[lastItem - 1].id;
        lastItemIndex = lastItem - 1;
        remItems = filteredMenu.items.slice(lastItem - 1, filteredMenu.items.length).map((item) => ({
            title: item.title,
            elements: item.children
        }));
    }

    const navItems = filteredMenu.items.slice(0, lastItemIndex + 1).map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} lastItem={lastItem} remItems={remItems} lastItemId={lastItemId} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default memo(MenuList);
